/* unplugin-vue-components disabled */import { defineComponent, reactive, toRefs } from 'vue';
import { getConfig } from '@/api/system';
export default defineComponent({
  setup() {
    const state = reactive({
      form: {
        switch: 1,
        type: 1
      }
    });
    onMounted(() => {
      fetchData();
    });
    const fetchData = async () => {
      const {
        data
      } = await getConfig({
        ident: 'service'
      });
      if (data && data.ident) state.form = Object.assign(state.form, data);
    };
    const changeShow = () => {
      state.form.type == 1 ? state.form.type = 0 : state.form.type = 1;
    };
    return {
      ...toRefs(state),
      fetchData,
      changeShow
    };
  }
});